import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ReactSVG } from 'react-svg';
import PropTypes from 'prop-types';

import ZpButton from 'components/zpButton';
import { importStatic } from 'utils';

import { toggleUserFavouriteCompany } from '../../../services/userService';
import {
  updateCompanyIsSaved,
  updateUserFavouriteCompanies,
} from '../../../store/companyPage/actions';
import { openLoginModal, updateAddCompanyToFavouriteInQueue } from '../../../store/modals/actions';

import classes from './index.module.css';

const propTypes = {
  criteria: PropTypes.shape({
    companyNameCPS: PropTypes.string.isRequired,
    companyID: PropTypes.string.isRequired,
    companyName: PropTypes.number.isRequired,
  }).isRequired,
};

const CompanyJobAlerts = ({
  criteria,
  updateUserFavouriteCompanies,
  updateCompanyIsSaved,
  updateAddCompanyToFavouriteInQueue,
  openLoginModal,
  favouriteCompanies,
  companyIsSaved,
  user,
}) => {
  const [isFavouriteLoading, setFavouriteLoading] = useState(false);
  const isUserLoggedIn = !!(user && user.isLoggedIn);

  const toggleSaveCompany = () => {
    if (isUserLoggedIn) {
      setFavouriteLoading(true);
      const payload = {
        companyName: criteria.companyNameCPS,
        companyNameCPS: criteria.companyNameCPS,
        companyID: criteria.companyID,
        key: criteria.companyName,
      };

      updateCompanyIsSaved(!companyIsSaved);
      toggleUserFavouriteCompany(payload, favouriteCompanies)
        .then((companies) => {
          updateUserFavouriteCompanies(companies);
        })
        .finally(() => {
          setFavouriteLoading(false);
        });
    } else {
      updateAddCompanyToFavouriteInQueue({
        companyName: criteria.companyNameCPS,
        companyNameCPS: criteria.companyNameCPS,
        companyID: criteria.companyID,
        key: criteria.companyName,
        selected: true,
      });
      openLoginModal({
        isFollowCompanyModal: true,
      });
    }
  };

  const getCalloutText = () => {
    return 'There are no results for your search.';
  };

  const getCalloutButtonContent = () => {
    let text = 'Create Alert';
    if (companyIsSaved) {
      text = 'Turn Off Alert';
    }
    return <span className="alerts-block-button-text">{text}</span>;
  };

  const getCalloutButtonIcon = () => {
    let iconSrc = companyIsSaved
      ? importStatic('/ui-router/images/icon-notification-off.svg')
      : importStatic('/ui-router/images/icon-notification.svg');
    return <ReactSVG className={classes['alerts-block-icon']} src={iconSrc} />;
  };

  const calloutText = getCalloutText();
  const calloutButtonIcon = getCalloutButtonIcon();
  const calloutButtonContent = getCalloutButtonContent();

  return (
    <div className={classes['alerts-block']}>
      <div className="alerts-block-item">
        <div className="alerts-block-text">{calloutText}</div>
      </div>
      <div className="alerts-block-item">
        <ZpButton
          theme="secondary"
          className={classes['alerts-block-button']}
          onClick={toggleSaveCompany}
          disabled={isFavouriteLoading}
          icon={calloutButtonIcon}
        >
          {calloutButtonContent}
        </ZpButton>
      </div>
    </div>
  );
};

const mapStateToProps = ({ jobs, user, companyPage }) => ({
  userListingHashes: jobs,
  user,
  companyIsSaved: companyPage.companyIsSaved,
  favouriteCompanies: companyPage.userFavouriteCompanies,
});

const mapDispatchToProps = {
  openLoginModal,
  updateUserFavouriteCompanies,
  updateCompanyIsSaved,
  updateAddCompanyToFavouriteInQueue,
};

CompanyJobAlerts.propTypes = propTypes;

export const CompanyJobAlertsComponent = CompanyJobAlerts;

export default connect(mapStateToProps, mapDispatchToProps)(CompanyJobAlerts);
